<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w74">
            <el-container>
                <el-aside width="330px">
                 <sidebar></sidebar>
                </el-aside>
                <el-main>
                  <companySide v-if="userType" :isButton="isButton" @release="gorelease()"></companySide>
                  <headSide v-else @release="gorelease()"></headSide>

                  <div style="margin-top:20px;">
                    <div style="text-align: left;">
                        <p style="display:none">
                         <span class="balance">可提现余额 :</span><span class="balance">&nbsp; ￥100</span>
                        </p>
                        <p class="remarks">备注：满{{drawalAmount}}可提现，提现申请提交需要后台审核，2-3个工作日到账</p>
                    </div>
                    <div class="column">
                        <p>选择提现到账账户</p>
                    </div>
                    <div  class="info_form" style="text-align: left;">
                        <div class="way mt-10">
                            <el-radio-group v-model="radio">
                                <!-- <el-radio label="微信账户" @change="getValue()"></el-radio> -->
                                <el-radio label="支付宝账户" @change="getValue()"></el-radio>
                                <el-radio label="银行卡"  @change="getValue()"></el-radio>
                           </el-radio-group>
                        </div>

                        <el-form ref="form" :rules="rules" :label-position="labelPosition" :model="form" label-width="100px">
                            <!-- <div v-if="radi_1" class="mt-20">
                                 <el-form-item label="用户姓名 :" prop="name" style="width:60%;">
                                  <el-input v-model="form.name"></el-input>
                                 </el-form-item>
                                <el-form-item label="微信账号 :" prop="weChatNumber" style="width:60%;">
                                    <el-input v-model="form.weChatNumber"></el-input>
                                </el-form-item>
                            </div> -->
                            <div v-if="radi_2" class="mt-20">
                                 <el-form-item label="用户姓名 :" prop="name" style="width:60%;">
                                  <el-input v-model="form.name"></el-input>
                                 </el-form-item>
                                <el-form-item label="支付宝账号 :" prop="alipayNumber" style="width:60%;">
                                    <el-input v-model="form.alipayNumber"></el-input>
                                </el-form-item>
                            </div>
                            <div v-if="radi_3" class="mt-20">
                                <el-form-item label="用户姓名 :" prop="name" style="width:60%;">
                                   <el-input v-model="form.name"></el-input>
                                 </el-form-item>
                                <el-form-item label="提现开户行 :" prop="accountName" style="width:60%;">
                                    <el-input v-model="form.accountName"></el-input>
                                </el-form-item>
                                <el-form-item label="提现账号 :" prop="accountNumber" style="width:60%;">
                                    <el-input v-model="form.accountNumber"></el-input>
                                </el-form-item>
                            </div>

                             <div class="tel">
                                <el-button type="success" @click="submitForm('form')">立即提现</el-button>
                            </div>
                        </el-form>


                    </div>
                  </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {getcashoutinfo,createcashoutorder}  from "@/api/coment";
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
export default {
    components:{
        sidebar,headSide,commBanner,titleHead,companySide
    },
    data(){
        return{
            obj:{
                title:'用户提现',
                roleType:'',
                personalType:9,
                companytype:''
            },
            isButton:false,
            cashoutparamdata:null,
            cashoutchannel:'cashoutA2',
            headTitle:'用户提现',
            form:{
                account:'', //选择账户类型
                name:'',//用户姓名
                accountName:'', //开户行
                accountNumber:'',//提现账号
                weChatNumber:'', //微信账号
                alipayNumber:'' //支付宝账号
            },
            rules:{
               account:[
                 { required: true, message: '选择提现到账账户', trigger: 'change' }
               ],
               name:[
                  { required: true, message: '请输入用户姓名', trigger: 'blur' },
                  { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
               ],
               accountName:[
                { required: true, message: '请输入提现开户行', trigger: 'blur' },
               ],
               accountNumber:[
                 { required: true, message: '请输入提现账号', trigger: 'blur' },
                 { min: 13, max: 21, message: '长度在 13 到 21个字符', trigger: 'blur' }
               ],
               weChatNumber:[{ required: true, message: '请输入微信账号', trigger: 'blur' },],
               alipayNumber:[{ required: true, message: '请输入支付宝账号', trigger: 'blur' },],
            },
            labelPosition:'left',
            radio:"支付宝账户",
            // radi_1:true,
            radi_2:true,
            radi_3:false,
            userType:false,
            drawalAmount :20
        }
    },
    created(){
        let type = this.$store.state.user.userInfo.type;
		this.obj.roleType = type;
        if(type == 3){
            this.userType = true;
        }
        // getcashoutparam().then((res)=>{
        //   this.cashoutparamdata=res.page;
        // })；
        getcashoutinfo().then((res)=>{
          if(res.code == 0){
            res.page.forEach((el)=>{
              if(el.name == 'cashoutPoint'){
                this.drawalAmount = el.cvalue;
              }
            })
           this.cashoutparamdata = res.page;
          }    
        })
    },
    methods:{
      submitForm(formName){
          this.$refs[formName].validate((valid) => {
          if (valid) {
              if(null!=this.cashoutparamdata && this.cashoutparamdata.length>0){
                 let i=Number(this.cashoutchannel.replace("cashoutA",""))-1;
                 let cashoutvalue= this.cashoutparamdata[i];
                 if(null!=cashoutvalue && undefined!=cashoutvalue){
                   let param={goodsid:cashoutvalue.id,amount:cashoutvalue.cvalue,cashoutinfo:JSON.stringify(this.form)};
                       createcashoutorder(param).then((res)=>{
                          if (res.code == 0) {
                             this.$message({
                              message:'提现申请已提交，待审核',
                              type:'success',
                              duration:1000
                              })
                            location.reload();
                          }
                       })
                 }
              }

          } else {
            return false;
          }
        });
      },
      getValue(){
         if(this.radio =='微信账户'){
            this.radi_1 = true;
            this.radi_2 = false;
            this.radi_3 = false;
            this.cashoutchannel="cashoutA2";
         }else if(this.radio =='支付宝账户'){
            this.radi_1 = false;
            this.radi_2 = true;
            this.radi_3 = false;
            this.cashoutchannel="cashoutA1";
         }else{
            this.radi_3 = true;
            this.radi_1 = false;
            this.radi_2 = false;
            this.cashoutchannel="cashoutA3";
         }
      },
      //发布需求
      gorelease(){
        this.$router.push('/demand')
      }
    }
}
</script>
<style scoped>
.mt-20{
    margin-top: 20px;
}
.balance{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.remarks{
    font-size: 13px;
    margin-top: 5px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
}
.column{
   width: 100%;
   height: 48px;
   background: #EEEEEE;
   margin-top: 20px;
}
.column p{
  height: 48px;
  line-height: 48px;
  text-align: left;
  margin-left: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.el-form-item{
   text-align: left;
    /* margin-bottom: 15px; */
}
.info_form>>>.el-input__inner{
    height: 50px;
}
.el-form-item__label{
    text-align: left;
}
.el-form-item__content{
    margin-left: 0 !important;
}
.el-button {
    margin-top: 20px;
}
.tel>>>.el-button--success{
    width: 114px;
    height: 35px;
    background: #68BE31;
    border-radius: 3px;
    line-height: 1px;
}


.way>>>.el-form-item__content{
    margin-left: 0px !important;
    margin-top: 20px;
}
.way>>>.el-radio__input.is-checked .el-radio__inner{
   border-color:#50B035;
   background: #50B035;
}
.way>>>.el-radio__input.is-checked+.el-radio__label{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/withdrawal.vue